import React, {useCallback, useEffect, useState} from 'react'
import {MunshiMenu} from "../components/Menu";
import {Button} from 'primereact/button';
import {axiosInstance} from "../utilities/AxiosConfig";
import {DataTable} from 'primereact/datatable';
import {ToastContainer} from 'react-toastify';
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";

import {Column} from "primereact/column";
import {ViewImages} from "../components/Image/ImageUtils";

import {PickDateRange} from "../components/Select/DateRangeSelect";
import Cookies from "js-cookie";
import {InventoryPrint} from "../print/InventoryPrint";
import {ItemSelect} from "../components/Select/ItemSelect";
import {useMediaQuery} from "react-responsive";
import {Auths} from "../utilities/getAuthDep";
import {formatDateToMySql} from "../utilities/ToMySqlDate";
import {Dropdown} from "primereact/dropdown";

export function Inventory({handle}) {
    const {loading, setLoading} = useSpinner();
    const [action, setAction] = useState(null);
    const [action1, setAction1] = useState(null);
    const [item, setItem] = useState({id: 0, name: "", itemGroup: 0, initialQuantity: 0, initialPrice: 0});
    const [proceed, setProceed] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [locationList, setLocationList] = useState([{id: 0, name: ""}]);
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    const isDesktop = useMediaQuery({query: '(min-width: 1024px)'})
    const [showInventory, setShowInventory] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [bioData, setBioData] = useState({});
    const [location, setLocation] = useState(0);
    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [bioRes, lcRes] = await Promise.all([
                    axiosInstance.get('biodata/'),
                    axiosInstance.get('location/')
                ]);
                setBioData(bioRes.data);
                let lcList = lcRes.data.map(loc => ({id: loc.id, name: loc.name}));
                setLocationList([{id: 0, name: "All"}, ...lcList]);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);
    useEffect(() => {
        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database'));
    }, [])
    // Loading Handle

    // Load Customer List
    useEffect(() => {
        setProceed(false)
        setLoading(true)
        axiosInstance.get(`/item/`).then((response) => {
            if (response.data && response.data.length > 0) {
                setItemList(response.data)
            } else {
                notify("No Item Found", "error")
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
                setProceed(true)
            }
        )


    }, [])
    const handlePrintOptions = () => {
        const dateString = dates[0].toLocaleDateString() + " - " + dates[1].toLocaleDateString()
        InventoryPrint(inventory, bioData.name, item.name, dateString)
    }
    // Load Ledger

    const loadInventoryLedger = () => {
        setLoading(true)
        if (location === 0) {
            axiosInstance.get(`/inventory/${item.id}&${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
                if (response.data && response.data.length > 0) {
                    setInventory(response.data)
                    setShowInventory(true)
                } else {
                    setInventory([])
                    setShowInventory(true)
                    notify("No Inventory Found", "error")
                }
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(() => {
                setLoading(false)
            })
        } else {
            axiosInstance.get(`/inventory/loc/${item.id}&${location}&${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
                if (response.data && response.data.length > 0) {
                    setInventory(response.data)
                    setShowInventory(true)
                } else {
                    setInventory([])
                    setShowInventory(true)
                    notify("No Inventory Found", "error")
                }
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(() => {
                setLoading(false)
            })
        }
    }


    const resetPage = useCallback(() => {
        setInventory([])
        setProceed(false)
        setShowInventory(false)
        setAction1(null)
        setAction(null)
        setItem({id: 0, name: "", itemGroup: 0, initialQuantity: 0, initialPrice: 0})
        setDates([new Date(), new Date()])
        setLoading(false)

    })
    const OptionSelect = () => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between mb-3 w-full gap-3 p-3 bg-gray-50 border-round shadow-1">
                <div className="flex flex-wrap gap-2">
                    <Button 
                        label="Proceed" 
                        icon="pi pi-sync"
                        onClick={() => loadInventoryLedger()}
                        disabled={!action && item.id === 0}
                        className="p-button-primary"
                    />
                    <Button 
                        label="Reset" 
                        icon="pi pi-refresh"
                        onClick={() => resetPage()}
                        className="p-button-outlined p-button-secondary"
                    />
                    <Button 
                        icon="pi pi-print"
                        tooltip="Print Ledger"
                        onClick={() => handlePrintOptions()}
                        disabled={!proceed && !action1}
                        className="p-button-outlined p-button-help"
                    />
                </div>

                <div className="flex align-items-center gap-3">
                    <div className="flex align-items-center">
                        <i className="pi pi-map-marker mr-2 text-primary"></i>
                        <label htmlFor="location-select" className="font-bold text-700 mr-2">LOCATION:</label>
                        <Dropdown
                            id="location-select"
                            value={location}
                            options={locationList}
                            optionLabel="name"
                            optionValue="id"
                            onChange={(e) => setLocation(e.value)}
                            placeholder="Select Location"
                            className="w-full md:w-14rem"
                        />
                    </div>
                </div>
            </div>
        );
    }
    const OptionInventorySelect = () => {
        if (!loading) {
            return (
                <>
                    <div
                        className="flex shadow-5 border-round-md flex-wrap w-full md:w-6 mx-auto p-1">
                        <div className="flex flex-row justify-content-evenly p-2 w-full">
                            {(action !== "Cash" && action !== "Cheque" && action !== "Sales" && action !== "Purchase" && action !== "Voucher" && action !== "CashBook") &&
                                <div className="flex flex-row w-10">
                                    <ItemSelect item={item || {id: 0, name: ""}} setItem={setItem}
                                                itemList={itemList}
                                                disable={false}/>
                                </div>}
                            <PickDateRange dates={dates} setDates={setDates}
                                           disable={item === null}/>
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <div className="flex flex-row justify-content-center">
                    <h1>Loading...</h1>
                </div>
            )
        }

    }
    const ShowInventory = () => {
        const [showImage, setShowImage] = useState(false)
        const [mode, setMode] = useState("")
        const [invoiceId, setInvoiceId] = useState(0)
        const handleTableClick = (data) => {
            setMode(data.data.mode)
            setInvoiceId(data.data.invoiceId)
            if (data.data.invoiceId > 0) {
                setShowImage(true)
            }

        }
        if (inventory.length === 0) {
            return (
                <div className="card">
                    <div className="flex flex-row justify-content-center">
                        <h1>No Inventory Found</h1>
                    </div>
                </div>
            )
        } else if (showImage) {
            return (
                <>
                    {showImage ? <ViewImages invoice={invoiceId} mode={mode} showImage={showImage}
                                             setShowImage={setShowImage}/> : null}

                </>
            )
        } else {
            return (
                <>
                    <div className="container card h-full">
                        <DataTable value={inventory} size="small" tableStyle={{minWidth: '50rem'}} showGridlines
                                   stripedRows onRowClick={(e) => handleTableClick(e)}>
                            <Column className="text-left text-xs " field="date" header="Date"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-left text-xs " field="invoiceId" header="Folio"
                                    style={{width: '5%'}} headerStyle={{width: '5%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'center'}></Column>
                            <Column className="text-left text-xs " field="customerName" header="Customer"
                                    style={{width: '5%'}} headerStyle={{width: '15%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-left text-xs " field="mode" header="Mode"
                                    style={{width: '5%'}} headerStyle={{width: '5%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-end text-xs " field="sold" header="Sale"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-end text-xs " field="purchase" header="Purchased"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-end text-xs " field="price" header="Price"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            {isDesktop && <Column className="text-start text-xs " field="location" header="Location"
                                                  style={{width: '10%'}} headerStyle={{width: '10%'}}
                                                  headerClassName={"text-left text-xs "}
                                                  alignHeader={'left'}></Column>}
                            <Column className="text-end text-xs " field="balance" header="Balance"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-left text-xs " field="comment" header="Comment"
                                    style={{width: '15%'}} headerStyle={{width: '15%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                        </DataTable>

                    </div>
                </>
            )
        }

    }


    if (!loading) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                <div className="flex flex-column justify-content-start   h-auto w-full mt-2 mr-2 ">
                    <div
                        className="container flex flex-column lg:flex-row justify-content-around align-items-start mr-3 w-full">
                        <OptionSelect/>
                        <OptionInventorySelect/>
                    </div>
                    <div className="flex flex-row justify-content-start w-full">
                        {showInventory &&
                            <div className="flex flex-row justify-content-start w-full mr-2 ml-2">
                                <ShowInventory/></div>}


                    </div>

                </div>
            </>
        )
    }


}

export default Inventory;
